<template>

  <v-autocomplete v-model="userSelected"
                  :label="label"
                  :placeholder="label"
                  :items="items"
                  item-text="preferredUsername"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  hide-no-data
                  :filter="v => v"
                  :search-input.sync="search"></v-autocomplete>

</template>

<script>

export default {
  name: 'UserSelector',
  props: ['label'],
  data () {
    return {
      previousLetterInput: '',
      search: '',
      loading: false,
      items: [],
      userSelected: null
    }
  },
  watch: {
    search (s) {
      this.previousLetterInput = s
      setTimeout(() => {
        if (s === this.previousLetterInput) {
          // Reset selection on empty search input
          if (s === '') {
            this.userSelected = null
          } else {
            this.loading = true
            this.items = []
            // Fetch new items, let the watcher add them to the list
            this.$store.dispatch('searchUsers', {
              preferredUsername: this.search || ''
            })
              .then(respitems => {
                for (const respitem of respitems.items) {
                  this.items.push(respitem)
                }
              })
              .catch(err => { console.error('Failed to fetch users : ', err) })
              .finally(() => { this.loading = false })
          }
        }
      }, 250)
    },
    'userSelected' () {
      this.$emit('input', this.userSelected)
      this.$emit('userSelected', this.items.find(item => item.id === this.userSelected))
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/UserSelector.vue